/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function firstWordFromClass() {
  const titles = document.querySelectorAll('.custom-title');
   
    
    titles.forEach(title => {
       const originalString = title.innerHTML;
       const splitWords = originalString.trim().split(" ");
       const trimmedString = originalString.trim()
      
    	title.innerHTML =
    	"<span class='article__intro--first-word'>"
    .concat(splitWords[0], "</span>") + "&#32;" + trimmedString.substr(trimmedString.indexOf(' ') + 1);
    })
}

firstWordFromClass();

  ///////////////// BLOG ////////////////////
  // Selectors
  const carousel = document.querySelector('.w-slider-mask');
  const carouselSlides = document.querySelectorAll('.slide'); 
  const nextBtn = document.querySelector('.right-arrow'); 
  const prevBtn = document.querySelector('.is-flipped'); 
  prevBtn.addEventListener('click', () => {
    console.log('jlakjdnkajnfladknka')
  })

  // counter
  let counter = 1;
  const size = carouselSlides[0].clientWidth;
 
  carousel.style.transform = 'translateX(' + (-size * counter) + 'px)';

  prevBtn.addEventListener('click', () => {
    console.log('clicked')
    carousel.style.transition= "transform 0.4s ease-in-out";
    counter--;
    console.log(counter);
    carousel.style.transform = 'translateX(' + (-size * counter) + 'px)';
  })
  nextBtn.addEventListener('click', () => {
    carousel.style.transition= "transform 0.4s ease-in-out";
    counter++;
    console.log(counter);
    carousel.style.transform = 'translateX(' + (-size * counter) + 'px)';
  })

  carousel.addEventListener('transitionend', ()=> {
    console.log('carouselSlides', carouselSlides[counter])
    if(carouselSlides[counter].id === 'lastClone'){
      carousel.style.transition= "none";
      counter = carouselSlides.length -2;
      carousel.style.transform = 'translateX(' + (-size * counter) + 'px)';
    }
  })
    carousel.addEventListener('transitionend', ()=> {
    console.log('carouselSlides', carouselSlides[counter])
    if(carouselSlides[counter].id === 'firstClone'){
      carousel.style.transition= "none";
      counter = carouselSlides.length - counter;
      carousel.style.transform = 'translateX(' + (-size * counter) + 'px)';
    }
  })
  
  


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
